import React from "react";

const ImageSection2 = () => {
  return (
    <section className="relative w-full pt-0 pb-8 md:pb-12 bg-white -mt-4 md:-mt-6">
      <div className="w-full">
        <img
          src="/c2.png"
          alt="Financial Solutions"
          className="w-full h-auto object-contain"
        />
      </div>
    </section>
  );
};

export default ImageSection2;

